/**
 * Created by luo on 03/09/2020.
 */
'use strict';

angular.module('contact', ['adf.provider', 'ui.router'])
.config(function ($stateProvider) {

  $stateProvider
    .state('contacts', {
      parent: 'betotrack',
      abstract: true,
      url: '/contact',
      ncyBreadcrumb: {
      skip: true
      }
    })
    .state('contacts.list', {
      url: '/list',
      views: {
        'content@app': {
          controller: 'contactsManagementCtrl',
          templateUrl: 'components/track/admin/contactManagement.tpl.html'
        }
      },
      ncyBreadcrumb: {
        label: 'contactsList.moduleName'
      }
    })
    .state('contacts.add', {
      url: '/add',
      views: {
        'content@app': {
          controller: 'contactsManagementAddEditCtrl',
          templateUrl: 'components/track/admin/contactManagementAddEdit.tpl.html'
        }
      },
      resolve: {
        editorModel: function () {
          return {
            mode: 'new',
          };
        }
      },
      ncyBreadcrumb: {
        parent: 'contacts.list',
        label: 'contactNew.new'
      }
    }).state('contacts.edit', {
      url: '/edit',
      views: {
        'content@app': {
          controller: 'contactsManagementAddEditCtrl',
          templateUrl: 'components/track/admin/contactManagementAddEdit.tpl.html'
        }
      },
      resolve: {
        editorModel: function () {
          return {
            mode: 'edit',
          };
        }
      },

      ncyBreadcrumb: {
        parent: 'contacts.list',
        label: 'contactNew.edit'
      }
    });

  })

.controller('contactsManagementAddEditCtrl', function($state, $scope, editorModel, contactMgmtService, toastService, $translate){

  $scope.contactDetail = {
    identifier: '',
    displayName: '',
    tellandline: '',
    telmobile:''
  };

  $scope.saveInProgress = false;

  $scope.cancel = function(){
    $state.go('contacts.list');
  };

  $scope.save = function(isStayOnSave){
    $scope.saveInProgress = true;
    $scope.saveSuccessful = false;
    contactMgmtService.saveContact($scope.contactDetail).then( function(){
      if(isStayOnSave){
        $scope.contactDetail = {
          identifier: '',
          displayName: '',
          tellandline: '',
          telmobile:''
        };
      }
      $scope.saveSuccessful = true;
      toastService.showSuccessToast($translate.instant('contactsList.saveSuccess'));
    }, function(response){
      console.error('Error saving Contact: ', response);
      toastService.showErrorToast({message: $translate.instant('contactsList.saveError'), type: 'F'});
    }).finally(function(){
      $scope.saveInProgress = false;
      if($scope.saveSuccessful && !isStayOnSave){
        $state.go('contacts.list');
      }
    });
  };

  if(editorModel.mode === 'new'){
      $scope.contactDetail = {
        identifier: '',
        displayName: '',
        tellandline: '',
        telmobile:''
      };
  } else {
      $scope.contactDetail =  contactMgmtService.getSelectedContact();
  }

  $scope.permissions = {};

  var checkContactsPermission = function(){
    return contactMgmtService.getContactAclRight().then(function(permission){
      $scope.permissions.contactsACL = permission;
    });
  };

  checkContactsPermission();
})
.controller('contactsManagementCtrl', function($scope, $timeout, toastService, $state, $window, commonTrackService, contactMgmtService, $uibModal, widgetSettingsCreatorService, $translate){
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    $scope.isDataAvailable = false;
    $scope.dataLoading = true;
    $scope.contactsManagementDetails = {
      selectedFunction:''
    };

    var deleteContact = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'components/track/telephone/deleteConfirm.tpl.html',
        controller: 'contactsDeleteCtrl',
        resolve: {
          selectedRowData: function () {
            return {};
          }
        }
      });

      modalInstance.result.then(function (result) {
        if (result === 'success') {
          var rowindex = $('#' + $scope.overviewGridPrefix + 'contactsList').jqxGrid('getselectedrowindex');
          if (rowindex > -1) {
            var id = $('#' + $scope.overviewGridPrefix + 'contactsList').jqxGrid('getrowid', rowindex);
            $('#' + $scope.overviewGridPrefix + 'contactsList').jqxGrid('deleterow', id);
          }
        } else if (result === 'error') {
          console.error('delete error');
        }
      });
    };

    var importFunction = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'components/track/admin/contactFileImport.tpl.html',
        controller: 'contactImportDilaogCtrl'
      });

      modalInstance.result.then(function (result) {
        toastService.showSuccessToast(result);
        $timeout(function () {
          $window.location.reload();
        }, 400);
      });

    };

    var showPositioningFunction = function(){
      $scope.showPositionOptions = true;
      disableDropDown(2);
    };

    $scope.savePositioning = function(){

      var positionData = [];

      for(var i=0;i<$scope.contactsListSource.localdata.length;i++) {
        var contact = $scope.contactsListSource.localdata[i];
        positionData.push({
          contactidentifier : contact.contactidentifier,
           position : i
        });
      }
      contactMgmtService.savePositions(positionData).then( function (){
        $scope.showPositionOptions = false;
        enableDropDown(2);
        toastService.showSuccessToast($translate.instant('contactsList.saveSuccess'));
        //reload contacts (retrieve the new positions from the db)..
        getContactList();
      }, function(response){
        console.error('Error saving Positions: ', response);
        toastService.showErrorToast({message: $translate.instant('contactsList.saveError'), type: 'F'});
      });

    };

    $scope.cancelPositioning = function(){

      $scope.showPositionOptions = false;
      // reload contacts (fetch new ones if any and refresh positions)
      enableDropDown(2);
      getContactList();
      var gridName = '#' + $scope.overviewGridPrefix + 'contactsList';
      $(gridName).jqxGrid({selectedrowindex: 0});
    };

    $scope.showPositionOptions = false;

    $scope.moreFunctionsSource = [{
        name: $translate.instant('moreFunction.functionList.delete'),
        operation: 'delete',
        disabled: true,
        execute: deleteContact
      }, {
        name: $translate.instant('moreFunction.functionList.fileImport'),
        operation: 'import',
        disabled: true,
        execute: importFunction
      }, {
        name: $translate.instant('moreFunction.functionList.contactPosition'), //'Show Positioning Options',//$translate.instant('moreFunction.functionList.fileImport'),
        operation: 'positionShow',
        disabled: false,
        execute: showPositioningFunction
      }];

    $scope.moreFuctionSetting = {
        placeHolder: $translate.instant('moreFunction.button.function'),
        displayMember: 'name',
        valueMember: 'operation',
        source: $scope.moreFunctionsSource,
        theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
        width: '200px',
        height: 30,
        autoDropDownHeight: true
    };

    $scope.moreFunctions = function () {
      for (var index in $scope.moreFunctionsSource) {
        var moreFunctionsItem = $scope.moreFunctionsSource[index];
          if (moreFunctionsItem.operation && moreFunctionsItem.operation === $scope.contactsManagementDetails.selectedFunction.operation) {
            moreFunctionsItem.execute();
            $scope.contactsManagementDetails.selectedFunction = '';
            break;
          }

        moreFunctionsItem = moreFunctionsItem;
      }
      $('#moreFunDropDown').jqxDropDownList('clearSelection');
    };

    var _tmpColumnProperties = [{
        name: 'name', width: '25%',
        type: 'string'
      }, {
        name: 'landline', width: '25%',
        type: 'string'
      }, {
        name: 'mobile', width: '25%',
        type: 'string'
      }];

    $scope.customGridProperties = {
        pagesize: 25,
        height: 600,
        autoheight: false,
        showfilterrow: true,
        filterable: true,
        columns: []
      };

    $scope.contactListRowSelectHandler = function (event) {
        if (event.type === 'rowselect' && event.args.row) {
          var selectedRow = event.args.row;
          var obj = {
            identifier: selectedRow.contactidentifier,
            displayName: selectedRow.contactdisplayname,
            tellandline: selectedRow.tellandline,
            telmobile: selectedRow.telmobile,
            position: selectedRow.position,
            row: selectedRow
          };
          contactMgmtService.setSelectedContact(obj);
        }
    };

    $scope.customGridProperties.columns = commonTrackService.getColumnProperties(_tmpColumnProperties, {}, {moduleName: 'contacts'});
    var _additionalProperties = {translatedName: $translate.instant('contactsList.moduleName')};

    $scope.contactsListGridSettings = {};
    $scope.contactsListSource =
    {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };

    $scope.swapRowPosition = function(isUp){
      var gridName = '#' + $scope.overviewGridPrefix + 'contactsList';
      var selectedIndex = $(gridName).jqxGrid('getselectedrowindex');
      var tempRow = $scope.contactsListGridSettings.source.records[selectedIndex];
      var rowIndex = selectedIndex;
      if(selectedIndex > -1)
      {
        if((isUp) && (selectedIndex > 0)){
          //console.log('Moving Row Up');
          $scope.contactsListSource.localdata[selectedIndex] =  $scope.contactsListSource.localdata[selectedIndex -1];
          $scope.contactsListSource.localdata[selectedIndex -1] = tempRow;
          rowIndex = selectedIndex - 1;

        } else if ((!isUp) && (selectedIndex < $scope.contactsListGridSettings.source.records.length - 1)) {
          //console.log('Moving Row Down');
          $scope.contactsListSource.localdata[selectedIndex] =  $scope.contactsListSource.localdata[selectedIndex +1];
          $scope.contactsListSource.localdata[selectedIndex + 1] = tempRow;
          rowIndex = selectedIndex + 1;
        }
        $scope.contactsListdataAdapter = new $.jqx.dataAdapter( $scope.contactsListSource, {
          autoBind: true
        });
        $scope.contactsListGridSettings.source = $scope.contactsListdataAdapter;
        $(gridName).jqxGrid('updatebounddata');
        $(gridName).jqxGrid({selectedrowindex: rowIndex});
        $(gridName).jqxGrid('gotopage', Math.floor(rowIndex / $(gridName).jqxGrid('getpaginginformation').pagesize));
      }
    };

    //contactsListGridSettings
    var getContactList = function () {
      var requestParam = {
        statusCode: 'all',
        vehicleGroup: null,
        dataRefresh: true,
        reportOptions: {}
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };

      $scope.dataLoading = true;

      return contactMgmtService.getContactList(param).then(function (contactIndexes) {
          $scope.isDataAvailable = true;
          if(!$scope.contactsListdataAdapter){
            $scope.customGridProperties.columns = commonTrackService.getColumnProperties(contactIndexes.gridSettings.overviewListGrids[0].columnProperties, contactIndexes.columnTranslation, { moduleName: 'contacts' });
            $scope.contactsListGridSettings = commonTrackService.getGridSettings('contacts', $scope.customGridProperties, null, _additionalProperties);
            $scope.contactsListSource.localdata = contactIndexes.dataList;
            $scope.contactsListdataAdapter = new $.jqx.dataAdapter( $scope.contactsListSource, {
              autoBind: true
            });
            $scope.contactsListGridSettings.source = $scope.contactsListdataAdapter;
            $scope.contactsListGridSettings.pagesize = 15;
          } else{
            $scope.contactsListSource.localdata = contactIndexes.dataList;
            commonTrackService.updateBoundData($scope.overviewGridPrefix + 'contactsList');
          }

        }, function (response) {
          if (response.data && response.data.message) {
            $scope.isDataAvailable = false;
          }
        }).finally(function(){
          if (!$scope.dataLoadingFinished) {
            $scope.dataLoadingFinished = true;
          }
          $scope.dataLoading = false;
        });
    };

    $scope.new = function () {
      $state.go('contacts.add');
    };

    $scope.edit = function () {
      $state.go('contacts.edit');
    };

    $scope.permissions = {};

    var checkContactsPermission = function(){
      return contactMgmtService.getContactAclRight().then(function(permission){
        $scope.permissions.contactsACL = permission;
      });
    };

    function enableDropDown(index) {
      $timeout(function () {
        $scope.moreFunctionsSource[index].disabled = false;
      },0,false );
    }

    function disableDropDown(index) {
      $timeout(function () {
        $scope.moreFunctionsSource[index].disabled = true;
      },0,false );
    }

    checkContactsPermission().then(function(){
      if($scope.permissions.contactsACL.aclRightLvel === 0){
        return;
      }
      return getContactList();
    }).finally(function(){
      $scope.dataLoading = false;
      if($scope.permissions.contactsACL && $scope.permissions.contactsACL.aclRightLvel > 0 ){
        if(Number($scope.permissions.contactsACL.aclRightLvel) === 3){
          // enable delete
          enableDropDown(0);
          // enable import
          enableDropDown(1);
        }else {
          // disable delete
          disableDropDown(0);
          // disable import
          disableDropDown(1);
        }
      }

    });

    $scope.$on('$destroy', function () {
      delete  $scope.contactsListGridSettings.source;
    });

})
.controller('contactsDeleteCtrl', function($scope, $uibModalInstance, $state, errorHandlingService, contactMgmtService){
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.onKeyPress = function ($event) {
    if ($event.keyCode === 13) {
      $scope.delete();
    }
  };

  $scope.delete = function () {
    var contactDetail = contactMgmtService.getSelectedContact();
    contactMgmtService.deleteContact(contactDetail.identifier).then(function () {
      $uibModalInstance.close('success');
      $state.go('contacts.list');
    },function(response) {
      $uibModalInstance.close('error');
      errorHandlingService.handleForCommonResponse(response);
    });
  };

})
.controller('contactImportDilaogCtrl', function ($scope,widgetSettingsCreatorService, bookManangementService, $timeout, $uibModalInstance, $translate, contactMgmtService, toastService) {
  $scope.isImportBtnDisabled = true;
  $scope.isImportBtnDisabled = true;
  $scope.importIntoBook = false;
  $scope.importBookName = '';
  $scope.bookList= [];
  $scope.isValid = true;



  $scope.fileChanged = function (element) {
    $scope.isFileinputDisabled = true;
    var file = element.files[0];
    var reader = new FileReader();
    $scope.isImportBtnDisabled = true;

    reader.onloadend = function (e) { //callback after files finish loading
      $scope.encodedData = e.target.result;
      $scope.isImportBtnDisabled = false;
      $scope.$apply();
      $scope.encodedData = $scope.encodedData.replace(/^data:text\/plain;base64,/, '');
      $scope.isFileinputDisabled = false;
      //here you can send data over your server as desired
    };
    reader.readAsDataURL(file);

  };

  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.getBookList = function () {

    var requestParam = {
      dataRefresh: true,
      reportOptions: {}
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };

    return bookManangementService.getBookList(param).then(function (bookIndexes){
      var _booklist = [];
      for (var x = 0; x < bookIndexes.dataList.length; x++) {
        _booklist.push(bookIndexes.dataList[x].bookdisplayname);
      }
      $scope.bookList= _booklist;
      console.log($scope.bookList);
    });
  };



  $scope.import = function () {

    $scope.isValid = true;
    $scope.importBookName = $('#import-bookName').val();
    $scope.invalidDataErrorMessage = '';
    if($scope.importIntoBook){
      if($scope.importBookName ===''){
        $scope.isValid = false;
        $scope.invalidDataErrorMessage = $translate.instant('contactsList.importErrorBookBlank');
      } else {
        for (var x = 0; x < $scope.bookList.length; x++) {
          if($scope.importBookName === $scope.bookList[x]){
            $scope.isValid = false;

            $scope.invalidDataErrorMessage = $translate.instant('contactsList.importErrorBookDuplicate');
            break;
          }
        }
      }
    }

    if($scope.isValid){
      if ($scope.encodedData) {
        contactMgmtService.importContacts($scope.encodedData,$scope.importIntoBook, $scope.importBookName ).then(function () {
          $uibModalInstance.close($translate.instant('telephonesList.telephoneImport.successAlert'));

        }, function (response) {
          var _messsage = response.data && response.data.errors && response.data.errors[0].code ? $translate.instant('errorCodes.restAPI.' + response.data.errors[0].code + '.message') : response.data.message;
          var errorAlert = {type: 'F', message: _messsage};
          toastService.showErrorToast(errorAlert);
        });
      }
    } else{
      console.error($scope.invalidDataErrorMessage);
      $timeout(function () {$scope.$digest();});
    }
  };

  $scope.getBookList();

  $timeout(function () {
    $('#contact-import-check').jqxCheckBox({theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme});
    $('#contact-import-check').bind('change', function (event) {
      $scope.importIntoBook = event.args.checked;
      $scope.$digest();
    });
  });

})
.service('contactMgmtService', function(crudService){
    var model = 'admin';

    this.getContactList = function(param){
      return crudService.customGET(model, 'contactlist', param);
    };

    this.selectedContact = {
      identifier: '',
      displayName: '',
      tellandline: '',
      telmobile: ''
    };

    this.getSelectedContact = function(){
      return this.selectedContact;
    };

    this.setSelectedContact = function(contactDetails){
      this.selectedContact = contactDetails;
    };

    this.saveContact= function(contactDetails){
      // filter out unneeded data from contact Details object
      var postObj = {
        contactidentifier: contactDetails.identifier,
        contactdisplayname: contactDetails.displayName,
        tellandline: contactDetails.tellandline ? contactDetails.tellandline : '',
        telmobile: contactDetails.telmobile ? contactDetails.telmobile : '',
        position: contactDetails.position
      };
      return crudService.post(model+ '/contact', postObj);
    };

    this.savePositions = function(contactPositions){
      return crudService.post(model+ '/contactpositions', contactPositions);
    };

    this.deleteContact = function(contactIdentifier){
      return crudService.delete(model + '/contact?key=' + encodeURIComponent(contactIdentifier));
    };

    this.importContacts = function(encodedFileString, bookImport, bookName){

      if(bookImport){
        return crudService.post(model+'/contact/import?bookImport='+bookImport+'&bookName='+bookName,encodedFileString);
      } else{
        return crudService.post(model+'/contact/import',encodedFileString);
      }

    };

    this.getContactAclRight= function(){
      return  crudService.get(model+'/contactsaclright');
    };

});





// WEBPACK FOOTER //
// ./.tmp/components/track/admin/contactManagement.js